<script setup>
import { RouterView } from 'vue-router'
import AppMenu from '@/components/AppMenu.vue'
</script>

<template>
  <AppMenu></AppMenu>

    <RouterView  v-slot="{Component}">
      <transition name="slide-fade" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </RouterView>

</template>
<script>

export default {
  data() {
    return {}
  }

}

</script>